import React, {useState} from "react"
import PropTypes from "prop-types"
import {RouteComponentProps} from "react-router-dom"

import {Col, Row} from "@irati/ui/src/Layout"
import DealByUrlSlug from "@irati/deals/apollo/query/DealByUrlSlug"
import ErrorText from "@irati/ui/src/ErrorText"
import notify from "@irati/utils/notify/notify"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {CheckoutRedemption, DealType} from "@irati/types"
import Redemption from "@irati/checkout/apollo/query/Redemption"
import tracking from "@irati-tracking/perks/perks"
import withPerkOrReward, {WithPerkOrReward} from "@irati-web/flexi-rewards/src/utils/withPerkOrReward"

import DealSuccessTickets from "../../components/Tickets"
import DealBanner from "../../components/DealBanner"
import RequireDealStatusOn from "../../components/RequireDealStatusOn"
import OrderSummary from "../../components/DealSuccess/SuccessOrderSummary"
import {getVouchersFromRedemption} from "../../helpers/redemption/getVouchersFromRedemption"
import AdsConvert from "../../components/ads/Convert"
import CashbackRedemptionSuccess from "../../components/DealSuccess/CashbackRedemptionSuccess"
import DealSuccessFinished from "../../components/DealSuccess/Finished"

interface Props extends RouteComponentProps<{redemptionId: string; urlSlug: string}>, InjectIntl, WithPerkOrReward {}

const DealSuccess: React.FC<Props> = (props) => {
  const [isTracked, setIsTracked] = useState(false)
  const {redemptionId, urlSlug} = props.match.params
  const {formatMessage} = props

  const showCashbackNotification = (redemption: CheckoutRedemption) => {
    if (redemption.order?.basket?.cashback?.amount > 0) {
      const amount = redemption.order?.basket?.cashback?.amount
      const message = formatMessage({id: "perks.redemption.cashback.success"}, {flexiPoints: amount / 100})
      notify.success({message, position: "top-right"})
    }
  }

  return (
    <div>
      <DealByUrlSlug variables={{urlSlug, isRewards: props.isRewards}}>
        {(d) => {
          if (!d.data || !d.data.dealBySlug)
            return (
              <>
                <RequireDealStatusOn deal={null} />
                <DealSuccessFinished />
              </>
            )
          const deal = d.data.dealBySlug

          if (!isTracked) {
            setIsTracked(true)
            tracking.redeemPerkFinishSuccess(deal)
          }

          return (
            <>
              <Redemption variables={{uuid: redemptionId}}>
                {({data}) => {
                  const checkoutRedemption = data?.checkoutRedemption

                  if (!checkoutRedemption) {
                    return <ErrorText>Oops</ErrorText>
                  }

                  const vouchers = getVouchersFromRedemption(checkoutRedemption, deal)
                  showCashbackNotification(checkoutRedemption)

                  return (
                    <>
                      <AdsConvert dealId={deal.uuid} />
                      <DealBanner deal={deal} showFavouriteIcon={false} />
                      {deal.type !== DealType.Cashback && (
                        <Row>
                          <Col mdOffset={3} md={6} xs={12}>
                            <DealSuccessTickets deal={deal} redemption={checkoutRedemption} vouchers={vouchers}>
                              <OrderSummary order={checkoutRedemption.order} />
                            </DealSuccessTickets>
                          </Col>
                        </Row>
                      )}
                      {deal.type === DealType.Cashback && (
                        <CashbackRedemptionSuccess deal={deal} redemption={checkoutRedemption} vouchers={vouchers} />
                      )}
                    </>
                  )
                }}
              </Redemption>
              {deal.type !== DealType.Cashback && <DealSuccessFinished />}
            </>
          )
        }}
      </DealByUrlSlug>
    </div>
  )
}

DealSuccess.contextTypes = {
  appPath: PropTypes.string
}

export default withPerkOrReward(injectIntl(DealSuccess))
